import { FunctionComponent } from 'react';
import { ViewProps } from './types';
import { FloatingIcon, Visible, Floating, Icon } from './styles';
import { getClassName } from '../../helpers';

const View: FunctionComponent<ViewProps> = ({ icon, elementRef, visible }) => (
  <FloatingIcon className="FloatingIcon" ref={elementRef}>
    <Visible className={getClassName('', { visible })}>
      <Floating>
        <Icon>{icon}</Icon>
      </Floating>
    </Visible>
  </FloatingIcon>
);

export default View;
